import Cookies from "js-cookie";
import { clearResponseEncryptKey } from '@/utils/responseDecrypt'

const TokenKey = "Admin-Token";
let memoryToken = "";

function getSessionToken() {
  try {
    return window.sessionStorage.getItem(TokenKey) || "";
  } catch {
    return "";
  }
}

export function getToken() {
  // 跨站 iframe 可能无法读写第三方 Cookie，优先使用当前页面会话中的 token。
  if (memoryToken) return memoryToken;
  const sessionToken = getSessionToken();
  if (sessionToken) return sessionToken;
  try {
    return Cookies.get(TokenKey);
  } catch {
    return undefined;
  }
}

export function setToken(token) {
  memoryToken = token;
  try {
    window.sessionStorage.setItem(TokenKey, token);
  } catch {
    // 存储受限时，当前页面仍可通过内存中的 token 继续使用 IM。
  }
  try {
    return Cookies.set(TokenKey, token);
  } catch {
    return undefined;
  }
}

export function removeToken() {
  memoryToken = "";
  try {
    window.sessionStorage.removeItem(TokenKey);
  } catch {
    // 存储受限时仍清理内存和 Cookie。
  }
  clearResponseEncryptKey()
  try {
    return Cookies.remove(TokenKey);
  } catch {
    return undefined;
  }
}
